import { render, staticRenderFns } from "./SupplementsCard.vue?vue&type=template&id=60846e54&scoped=true"
import script from "./SupplementsCard.vue?vue&type=script&lang=js"
export * from "./SupplementsCard.vue?vue&type=script&lang=js"
import style0 from "./SupplementsCard.vue?vue&type=style&index=0&id=60846e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60846e54",
  null
  
)

export default component.exports